import type { JSX } from 'react';
import { CATEGORY_MARK, type EventCategory } from './category.js';

/**
 * Generated gradient mark for a category. No organizer photos: the art is
 * paint plus a decorative emoji. Callers render the category name as text
 * beside this mark, so the gradient is not the name.
 */
export function CategoryArt({ category }: { category: EventCategory }): JSX.Element {
  return (
    <span className={`category-art category-art--${category}`} aria-hidden="true">
      <span className="category-art__mark">{CATEGORY_MARK[category]}</span>
    </span>
  );
}
